/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} No_Shortforms_AddedInputs */



/**
* | output |
* | --- |
* | "No shortforms added to this list yet" |
*
* @param {No_Shortforms_AddedInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const no_shortforms_added = /** @type {((inputs?: No_Shortforms_AddedInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<No_Shortforms_AddedInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Aucune abréviation ajoutée à cette liste")
	if (locale === "de") return /** @type {LocalizedString} */ ("Dieser Liste wurden noch keine Kurzformen hinzugefügt.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Nessuna forma abbreviata è stata ancora aggiunta a questo elenco")
	if (locale === "ru") return /** @type {LocalizedString} */ ("В этот список пока не добавлены никакие сокращения.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Aún no se han añadido atajos a esta lista")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("此列表尚未添加任何缩写形式。")
	if (locale === "ja") return /** @type {LocalizedString} */ ("このリストにはまだショートフォームが追加されていません")
	if (locale === "hi") return /** @type {LocalizedString} */ ("इस सूची में अभी तक कोई संक्षिप्त रूप नहीं जोड़ा गया है।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Nenhuma abreviação foi adicionada a esta lista ainda.")
	return /** @type {LocalizedString} */ ("No shortforms added to this list yet")
});